import { apiClient } from "../config";

async function readNotification(id: any) {
  const res = await apiClient.put(`/admin/notifications/read/${id}`);
  return res.data;
}

export default readNotification;
